/**
 * LOS FILTROS DE UNA LISTA, EN LA DIRECCIÓN (14-10, RUT-12).
 *
 * En Clientes el buscador y los filtros vivían solo en el estado de la pantalla: al abrir una
 * ficha y volver atrás (o recargar) la lista salía entera otra vez, y repasar una lista
 * filtrada cliente a cliente obligaba a filtrar de nuevo cada vez.
 *
 * Dos funciones puras: leer los filtros de `?q=...&plan=...` y escribirlos. Lo que está en su
 * valor por defecto NO se escribe (la dirección de siempre sigue siendo la de siempre), y los
 * parámetros que no son filtros de esta lista (`orden`, por ejemplo) se respetan.
 */

/**
 * @param {string} search        `window.location.search`
 * @param {Object} porDefecto    {clave: valor por defecto}; solo se leen estas claves
 * @param {Object} [admitidos]   {clave: [valores que valen]}; lo que no esté vuelve al defecto
 */
export function leerFiltros(search, porDefecto, admitidos = {}) {
    const params = new URLSearchParams(search || '');
    const fuera = {};
    Object.entries(porDefecto).forEach(([clave, defecto]) => {
        const valor = params.get(clave);
        const vale = valor !== null && valor !== ''
            && (!admitidos[clave] || admitidos[clave].includes(valor));
        fuera[clave] = vale ? valor : defecto;
    });
    return fuera;
}

/** La `search` nueva (con su «?», o cadena vacía) con esos filtros puestos. */
export function escribirFiltros(search, filtros, porDefecto) {
    const params = new URLSearchParams(search || '');
    Object.entries(porDefecto).forEach(([clave, defecto]) => {
        const valor = filtros[clave];
        if (valor === undefined || valor === null || String(valor).trim() === '' || valor === defecto) {
            params.delete(clave);
        } else {
            params.set(clave, String(valor));
        }
    });
    const texto = params.toString();
    return texto ? `?${texto}` : '';
}
